/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ChannelType } from '../model';
// @ts-ignore
import { GetSafarMarketHotelResponse } from '../model';
// @ts-ignore
import { GetSafarMarketRoomResponse } from '../model';
// @ts-ignore
import { HotelCityFullDetailView } from '../model';
// @ts-ignore
import { HotelFiltersRequest } from '../model';
// @ts-ignore
import { HotelFiltersResponse } from '../model';
// @ts-ignore
import { HotelListResponse } from '../model';
// @ts-ignore
import { HotelPricesRequest } from '../model';
// @ts-ignore
import { HotelPricesResponse } from '../model';
// @ts-ignore
import { HotelRoomSearchRequest } from '../model';
// @ts-ignore
import { HotelSearchResponse } from '../model';
// @ts-ignore
import { HotelSearchView } from '../model';
// @ts-ignore
import { HotelsCitiesQuickSearchResponse } from '../model';
// @ts-ignore
import { KojaraHotelsResponse } from '../model';
// @ts-ignore
import { SafarMarketGetHotelResponse } from '../model';
// @ts-ignore
import { SafarMarketHotelSeachRequest } from '../model';
// @ts-ignore
import { SafarMarketSearchByIndexRequest } from '../model';
// @ts-ignore
import { SafarMarketSearchWithoutRoomRequest } from '../model';
// @ts-ignore
import { SafarMarketSearchWithoutRoomResponse } from '../model';
// @ts-ignore
import { SearchTermListRequest } from '../model';
/**
 * HotelSearchApiApiHotelsBundleGet - axios parameter creator
 * 
 * @param {number} [adultCount] 
 * @param {number} [childrenCount] 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [cityId] 
 * @param {ChannelType} [channelType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsBundleGetAxiosParamCreator (adultCount?: number, childrenCount?: number, from?: string, to?: string, cityId?: number, channelType?: ChannelType, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/bundle`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (cityId !== undefined) {
        localVarQueryParameter['cityId'] = cityId;
    }

    if (channelType !== undefined) {
        localVarQueryParameter['channelType'] = channelType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsGetHotelsFiltersPost - axios parameter creator
 * 
 * @param {HotelFiltersRequest} [hotelFiltersRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsGetHotelsFiltersPostAxiosParamCreator (hotelFiltersRequest?: HotelFiltersRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/getHotelsFilters`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(hotelFiltersRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsGetHotelsPricesPost - axios parameter creator
 * 
 * @param {HotelPricesRequest} [hotelPricesRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsGetHotelsPricesPostAxiosParamCreator (hotelPricesRequest?: HotelPricesRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/getHotelsPrices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(hotelPricesRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsGetSafarMarketRoomsPost - axios parameter creator
 * 
 * @param {HotelRoomSearchRequest} [hotelRoomSearchRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsGetSafarMarketRoomsPostAxiosParamCreator (hotelRoomSearchRequest?: HotelRoomSearchRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/GetSafarMarketRooms`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(hotelRoomSearchRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsHotelFullListGet - axios parameter creator
 * 
 * @summary Get hotel List
 * @param {string} [hotelName] 
 * @param {number} [hotelId] 
 * @param {number} [cityId] 
 * @param {number} [hotelTypeId] 
 * @param {boolean} [isActive] 
 * @param {number} [pageSize] 
 * @param {number} [pageNumber] 
 * @param {number} [providerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsHotelFullListGetAxiosParamCreator (hotelName?: string, hotelId?: number, cityId?: number, hotelTypeId?: number, isActive?: boolean, pageSize?: number, pageNumber?: number, providerId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/HotelFullList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (hotelName !== undefined) {
        localVarQueryParameter['hotelName'] = hotelName;
    }

    if (hotelId !== undefined) {
        localVarQueryParameter['hotelId'] = hotelId;
    }

    if (cityId !== undefined) {
        localVarQueryParameter['cityId'] = cityId;
    }

    if (hotelTypeId !== undefined) {
        localVarQueryParameter['hotelTypeId'] = hotelTypeId;
    }

    if (isActive !== undefined) {
        localVarQueryParameter['isActive'] = isActive;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }

    if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
    }

    if (providerId !== undefined) {
        localVarQueryParameter['providerId'] = providerId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsKojaroGet - axios parameter creator
 * 
 * @param {number} [offset] 
 * @param {number} [limit] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsKojaroGetAxiosParamCreator (offset?: number, limit?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/kojaro`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
    }

    if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsListGet - axios parameter creator
 * 
 * @summary searching for hotels and cities
 * @param {string} [searchTerm] search term to search on
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsListGetAxiosParamCreator (searchTerm?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/list`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (searchTerm !== undefined) {
        localVarQueryParameter['searchTerm'] = searchTerm;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsListPost - axios parameter creator
 * 
 * @param {SearchTermListRequest} [searchTermListRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsListPostAxiosParamCreator (searchTermListRequest?: SearchTermListRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/list`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(searchTermListRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsNearByHotelsGet - axios parameter creator
 * 
 * @param {number} [hotelId] 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsNearByHotelsGetAxiosParamCreator (hotelId?: number, from?: string, to?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/NearByHotels`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (hotelId !== undefined) {
        localVarQueryParameter['hotelId'] = hotelId;
    }

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPost - axios parameter creator
 * 
 * @param {SafarMarketSearchByIndexRequest} [safarMarketSearchByIndexRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPostAxiosParamCreator (safarMarketSearchByIndexRequest?: SafarMarketSearchByIndexRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/SafarMarketGetHotelByIndex`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(safarMarketSearchByIndexRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsSafarMarketHotelsSearchPost - axios parameter creator
 * 
 * @param {SafarMarketHotelSeachRequest} [safarMarketHotelSeachRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsSafarMarketHotelsSearchPostAxiosParamCreator (safarMarketHotelSeachRequest?: SafarMarketHotelSeachRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/SafarMarketHotelsSearch`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(safarMarketHotelSeachRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsSafarMarketWithoutRoomsPost - axios parameter creator
 * 
 * @param {SafarMarketSearchWithoutRoomRequest} [safarMarketSearchWithoutRoomRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsSafarMarketWithoutRoomsPostAxiosParamCreator (safarMarketSearchWithoutRoomRequest?: SafarMarketSearchWithoutRoomRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/SafarMarketWithoutRooms`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(safarMarketSearchWithoutRoomRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsSearchGet - axios parameter creator
 * 
 * @summary search city hotels
 * @param {number} [adultCount] 
 * @param {number} [childrenCount] 
 * @param {number} [roomCount] 
 * @param {string} [from] starting date
 * @param {string} [to] finish date
 * @param {string} [cityName] desired city name, alternative to city id
 * @param {number} [cityId] desired city id, alternative to city name
 * @param {boolean} [hasHotelInName] 
 * @param {string} [tag] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsSearchGetAxiosParamCreator (adultCount?: number, childrenCount?: number, roomCount?: number, from?: string, to?: string, cityName?: string, cityId?: number, hasHotelInName?: boolean, tag?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/search`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (cityName !== undefined) {
        localVarQueryParameter['cityName'] = cityName;
    }

    if (cityId !== undefined) {
        localVarQueryParameter['cityId'] = cityId;
    }

    if (hasHotelInName !== undefined) {
        localVarQueryParameter['hasHotelInName'] = hasHotelInName;
    }

    if (tag !== undefined) {
        localVarQueryParameter['tag'] = tag;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelSearchApiApiHotelsSearchstaticsGet - axios parameter creator
 * 
 * @summary search city hotels
 * @param {number} [adultCount] 
 * @param {number} [childrenCount] 
 * @param {number} [roomCount] 
 * @param {string} [from] starting date
 * @param {string} [to] finish date
 * @param {string} [cityName] desired city name, alternative to city id
 * @param {number} [cityId] desired city id, alternative to city name
 * @param {boolean} [hasHotelInName] 
 * @param {string} [tag] 
 * @param {number} [stars] 
 * @param {number} [pageNumber] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelSearchApiApiHotelsSearchstaticsGetAxiosParamCreator (adultCount?: number, childrenCount?: number, roomCount?: number, from?: string, to?: string, cityName?: string, cityId?: number, hasHotelInName?: boolean, tag?: string, stars?: number, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotels/searchstatics`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childrenCount !== undefined) {
        localVarQueryParameter['childrenCount'] = childrenCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (cityName !== undefined) {
        localVarQueryParameter['cityName'] = cityName;
    }

    if (cityId !== undefined) {
        localVarQueryParameter['cityId'] = cityId;
    }

    if (hasHotelInName !== undefined) {
        localVarQueryParameter['hasHotelInName'] = hasHotelInName;
    }

    if (tag !== undefined) {
        localVarQueryParameter['tag'] = tag;
    }

    if (stars !== undefined) {
        localVarQueryParameter['stars'] = stars;
    }

    if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiHotelsBundleGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsBundleGetRequest
 */
export interface HotelSearchApiApiHotelsBundleGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsBundleGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsBundleGet
     */
    readonly childrenCount?: number

    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsBundleGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsBundleGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsBundleGet
     */
    readonly cityId?: number

    /**
     * 
     * @type {ChannelType}
     * @memberof HotelSearchApiApiHotelsBundleGet
     */
    readonly channelType?: ChannelType
}

/**
 * Request parameters for apiHotelsGetHotelsFiltersPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsGetHotelsFiltersPostRequest
 */
export interface HotelSearchApiApiHotelsGetHotelsFiltersPostRequest {
    /**
     * 
     * @type {HotelFiltersRequest}
     * @memberof HotelSearchApiApiHotelsGetHotelsFiltersPost
     */
    readonly hotelFiltersRequest?: HotelFiltersRequest
}

/**
 * Request parameters for apiHotelsGetHotelsPricesPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsGetHotelsPricesPostRequest
 */
export interface HotelSearchApiApiHotelsGetHotelsPricesPostRequest {
    /**
     * 
     * @type {HotelPricesRequest}
     * @memberof HotelSearchApiApiHotelsGetHotelsPricesPost
     */
    readonly hotelPricesRequest?: HotelPricesRequest
}

/**
 * Request parameters for apiHotelsGetSafarMarketRoomsPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsGetSafarMarketRoomsPostRequest
 */
export interface HotelSearchApiApiHotelsGetSafarMarketRoomsPostRequest {
    /**
     * 
     * @type {HotelRoomSearchRequest}
     * @memberof HotelSearchApiApiHotelsGetSafarMarketRoomsPost
     */
    readonly hotelRoomSearchRequest?: HotelRoomSearchRequest
}

/**
 * Request parameters for apiHotelsHotelFullListGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsHotelFullListGetRequest
 */
export interface HotelSearchApiApiHotelsHotelFullListGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly hotelName?: string

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly hotelId?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly cityId?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly hotelTypeId?: number

    /**
     * 
     * @type {boolean}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly isActive?: boolean

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsHotelFullListGet
     */
    readonly providerId?: number
}

/**
 * Request parameters for apiHotelsKojaroGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsKojaroGetRequest
 */
export interface HotelSearchApiApiHotelsKojaroGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsKojaroGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsKojaroGet
     */
    readonly limit?: number
}

/**
 * Request parameters for apiHotelsListGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsListGetRequest
 */
export interface HotelSearchApiApiHotelsListGetRequest {
    /**
     * search term to search on
     * @type {string}
     * @memberof HotelSearchApiApiHotelsListGet
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for apiHotelsListPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsListPostRequest
 */
export interface HotelSearchApiApiHotelsListPostRequest {
    /**
     * 
     * @type {SearchTermListRequest}
     * @memberof HotelSearchApiApiHotelsListPost
     */
    readonly searchTermListRequest?: SearchTermListRequest
}

/**
 * Request parameters for apiHotelsNearByHotelsGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsNearByHotelsGetRequest
 */
export interface HotelSearchApiApiHotelsNearByHotelsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsNearByHotelsGet
     */
    readonly hotelId?: number

    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsNearByHotelsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsNearByHotelsGet
     */
    readonly to?: string
}

/**
 * Request parameters for apiHotelsSafarMarketGetHotelByIndexPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPostRequest
 */
export interface HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPostRequest {
    /**
     * 
     * @type {SafarMarketSearchByIndexRequest}
     * @memberof HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPost
     */
    readonly safarMarketSearchByIndexRequest?: SafarMarketSearchByIndexRequest
}

/**
 * Request parameters for apiHotelsSafarMarketHotelsSearchPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsSafarMarketHotelsSearchPostRequest
 */
export interface HotelSearchApiApiHotelsSafarMarketHotelsSearchPostRequest {
    /**
     * 
     * @type {SafarMarketHotelSeachRequest}
     * @memberof HotelSearchApiApiHotelsSafarMarketHotelsSearchPost
     */
    readonly safarMarketHotelSeachRequest?: SafarMarketHotelSeachRequest
}

/**
 * Request parameters for apiHotelsSafarMarketWithoutRoomsPost operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsSafarMarketWithoutRoomsPostRequest
 */
export interface HotelSearchApiApiHotelsSafarMarketWithoutRoomsPostRequest {
    /**
     * 
     * @type {SafarMarketSearchWithoutRoomRequest}
     * @memberof HotelSearchApiApiHotelsSafarMarketWithoutRoomsPost
     */
    readonly safarMarketSearchWithoutRoomRequest?: SafarMarketSearchWithoutRoomRequest
}

/**
 * Request parameters for apiHotelsSearchGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsSearchGetRequest
 */
export interface HotelSearchApiApiHotelsSearchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly childrenCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly roomCount?: number

    /**
     * starting date
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly from?: string

    /**
     * finish date
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly to?: string

    /**
     * desired city name, alternative to city id
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly cityName?: string

    /**
     * desired city id, alternative to city name
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly cityId?: number

    /**
     * 
     * @type {boolean}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly hasHotelInName?: boolean

    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchGet
     */
    readonly tag?: string
}

/**
 * Request parameters for apiHotelsSearchstaticsGet operation in HotelSearchApi.
 * @export
 * @interface HotelSearchApiApiHotelsSearchstaticsGetRequest
 */
export interface HotelSearchApiApiHotelsSearchstaticsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly childrenCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly roomCount?: number

    /**
     * starting date
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly from?: string

    /**
     * finish date
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly to?: string

    /**
     * desired city name, alternative to city id
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly cityName?: string

    /**
     * desired city id, alternative to city name
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly cityId?: number

    /**
     * 
     * @type {boolean}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly hasHotelInName?: boolean

    /**
     * 
     * @type {string}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly tag?: string

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly stars?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof HotelSearchApiApiHotelsSearchstaticsGet
     */
    readonly pageSize?: number
}

/**
* 
* @param {HotelSearchApiApiHotelsBundleGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsBundleGet(requestParameters: HotelSearchApiApiHotelsBundleGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsBundleGetAxiosParamCreator(requestParameters.adultCount, requestParameters.childrenCount, requestParameters.from, requestParameters.to, requestParameters.cityId, requestParameters.channelType, options, configuration);
    const request: () => AxiosPromise<HotelCityFullDetailView> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsGetHotelsFiltersPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsGetHotelsFiltersPost(requestParameters: HotelSearchApiApiHotelsGetHotelsFiltersPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsGetHotelsFiltersPostAxiosParamCreator(requestParameters.hotelFiltersRequest, options, configuration);
    const request: () => AxiosPromise<HotelFiltersResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsGetHotelsPricesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsGetHotelsPricesPost(requestParameters: HotelSearchApiApiHotelsGetHotelsPricesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsGetHotelsPricesPostAxiosParamCreator(requestParameters.hotelPricesRequest, options, configuration);
    const request: () => AxiosPromise<Array<HotelPricesResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsGetSafarMarketRoomsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsGetSafarMarketRoomsPost(requestParameters: HotelSearchApiApiHotelsGetSafarMarketRoomsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsGetSafarMarketRoomsPostAxiosParamCreator(requestParameters.hotelRoomSearchRequest, options, configuration);
    const request: () => AxiosPromise<GetSafarMarketRoomResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get hotel List
* @param {HotelSearchApiApiHotelsHotelFullListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsHotelFullListGet(requestParameters: HotelSearchApiApiHotelsHotelFullListGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsHotelFullListGetAxiosParamCreator(requestParameters.hotelName, requestParameters.hotelId, requestParameters.cityId, requestParameters.hotelTypeId, requestParameters.isActive, requestParameters.pageSize, requestParameters.pageNumber, requestParameters.providerId, options, configuration);
    const request: () => AxiosPromise<HotelListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsKojaroGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsKojaroGet(requestParameters: HotelSearchApiApiHotelsKojaroGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsKojaroGetAxiosParamCreator(requestParameters.offset, requestParameters.limit, options, configuration);
    const request: () => AxiosPromise<KojaraHotelsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary searching for hotels and cities
* @param {HotelSearchApiApiHotelsListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsListGet(requestParameters: HotelSearchApiApiHotelsListGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsListGetAxiosParamCreator(requestParameters.searchTerm, options, configuration);
    const request: () => AxiosPromise<HotelsCitiesQuickSearchResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsListPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsListPost(requestParameters: HotelSearchApiApiHotelsListPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsListPostAxiosParamCreator(requestParameters.searchTermListRequest, options, configuration);
    const request: () => AxiosPromise<HotelsCitiesQuickSearchResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsNearByHotelsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsNearByHotelsGet(requestParameters: HotelSearchApiApiHotelsNearByHotelsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsNearByHotelsGetAxiosParamCreator(requestParameters.hotelId, requestParameters.from, requestParameters.to, options, configuration);
    const request: () => AxiosPromise<Array<HotelSearchView>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPost(requestParameters: HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsSafarMarketGetHotelByIndexPostAxiosParamCreator(requestParameters.safarMarketSearchByIndexRequest, options, configuration);
    const request: () => AxiosPromise<SafarMarketGetHotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsSafarMarketHotelsSearchPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsSafarMarketHotelsSearchPost(requestParameters: HotelSearchApiApiHotelsSafarMarketHotelsSearchPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsSafarMarketHotelsSearchPostAxiosParamCreator(requestParameters.safarMarketHotelSeachRequest, options, configuration);
    const request: () => AxiosPromise<GetSafarMarketHotelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelSearchApiApiHotelsSafarMarketWithoutRoomsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsSafarMarketWithoutRoomsPost(requestParameters: HotelSearchApiApiHotelsSafarMarketWithoutRoomsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsSafarMarketWithoutRoomsPostAxiosParamCreator(requestParameters.safarMarketSearchWithoutRoomRequest, options, configuration);
    const request: () => AxiosPromise<SafarMarketSearchWithoutRoomResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary search city hotels
* @param {HotelSearchApiApiHotelsSearchGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsSearchGet(requestParameters: HotelSearchApiApiHotelsSearchGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsSearchGetAxiosParamCreator(requestParameters.adultCount, requestParameters.childrenCount, requestParameters.roomCount, requestParameters.from, requestParameters.to, requestParameters.cityName, requestParameters.cityId, requestParameters.hasHotelInName, requestParameters.tag, options, configuration);
    const request: () => AxiosPromise<HotelSearchResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary search city hotels
* @param {HotelSearchApiApiHotelsSearchstaticsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelSearchApiApiHotelsSearchstaticsGet(requestParameters: HotelSearchApiApiHotelsSearchstaticsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelSearchApiApiHotelsSearchstaticsGetAxiosParamCreator(requestParameters.adultCount, requestParameters.childrenCount, requestParameters.roomCount, requestParameters.from, requestParameters.to, requestParameters.cityName, requestParameters.cityId, requestParameters.hasHotelInName, requestParameters.tag, requestParameters.stars, requestParameters.pageNumber, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<HotelSearchResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
